<template>
  <div id="zt661">
    <div id="z1">
      <div>嵌入式条码识读器ZT661</div>
      <label>性能强劲，适合嵌入各种行业的产品中</label>
    </div>
    <div id="z2">
      <label>
        ZT661扫描模块独特的完全一体化设计，在极小的尺寸内完全集成图像采集、照明瞄准和解码器，既小又轻，性能强劲。适合嵌入各种行业的产品中使用，如数据采集器、PDA物流快递柜、电商自提柜、自助查询终端、排队叫号设备、彩票机、证件制造等。
      </label>
    </div>
    <div id="z3">
      <div>一体化设计，小巧轻盈</div>
      <div>独特的完全一体化设计，极小的尺寸内完全集成图像采集、照明瞄准和解码</div>
    </div>
    <div id="z4">
      <div>识读功能强大，支持各类主流条码</div>
      <div>可识读各类主流的一维条码和标准二维条码，以及中国的二维条码标准汉信码</div>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'zt661',
        data: [
          {label: '通讯接口', desc: ['USB-B接口×1'], pic: 'port.png'},
          {label: '输入电压', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: '照明', desc: ['白光LED'], pic: 'light.png'},
          {label: '对焦', desc: ['红光650nm±10nm'], pic: 'focus.png'},
          {label: '识读功能', desc: ['可识读一维码、二维码、识别景深'], pic: 'recon.png'},
          {label: '识读精度', desc: ['≥4mil'], pic: 'recac.png'},
          {label: '环境光照', desc: ['0 ~ 100000 lux（自然光）'], pic: 'envlig.png'},
          {label: '产品尺寸', desc: ['55.4mm×52mm×30mm'], pic: 'size.png'},
          {label: '图像传感器', desc: ['640×480 CMOS'], pic: 'imgss.png'},
          {label: '适用环境', desc: ['工作温度：-20℃～+50℃', '存储温度：-25℃～+70℃', '相对湿度：10%～90% RH (无凝结露) '], pic: 'env.png'}
          
        ]
      },
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt661 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt661/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.49rem;
  color: #FFFFFF;
}
#z1 div {
  margin-top: 2.69rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  margin-top: .2rem;
  font-size: .4rem;
  font-weight: 330;
}
#z1 img {
  width: 3.03rem;
}
#z2 {
  height: 1.78rem;
  background: #C2A88D;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 10.21rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .4rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt661/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 10.5rem;
}
#z3 div:nth-child(1) {
  margin-top: 3.12rem;
  font-size: .56rem;
  font-weight: bold;
  color: #4D4B49;
}
#z3 div:nth-child(2) {
  width: 4.56rem;
  margin-top: .22rem;
  font-size: .24rem;
  font-weight: 400;
  color: #333333;
}


#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt661/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.84rem;
  color: #333333;
}
#z4 div:nth-child(1) {
  margin-top: 2.25rem;
  font-size: .6rem;
  font-weight: bold;
}
#z4 div:nth-child(2) {
  width: 4.87rem;
  margin-top: .27rem;
  font-size: .24rem;
  font-weight: 350;
}
</style>
